import React from 'react';
import NavigationWithAuth from './NavigationWithAuth';
import FooterSEOLinks from '../layout/FooterSEOLinks';

interface MarketingLayoutProps {
  children: React.ReactNode;
}

export default function MarketingLayout({ children }: MarketingLayoutProps) {
  return (
    <div className="min-h-screen flex flex-col bg-premium-darker w-full text-sm">
      <NavigationWithAuth />
      <main id="main-content" className="flex-grow flex flex-col w-full min-h-screen">
        {children}
      </main>
      <footer className="w-full bg-gray-900 text-gray-300 py-12 border-t border-gray-800">
        <div className="container max-w-7xl mx-auto px-4">
          {/* Main footer content */}
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
            <div className="md:col-span-1">
              <h3 className="text-white font-bold text-lg mb-4">Paslawski Capital Management</h3>
              <p className="text-sm text-gray-400 mb-4">
                Elite financial strategies for high-net-worth Canadians. Building lasting legacies through innovative wealth management.
              </p>
              <div className="space-y-2">
                <p className="text-sm text-gray-400">
                  <a href="tel:306-861-4995" className="hover:text-white transition-colors">306-861-4995</a>
                </p>
                <p className="text-sm text-gray-400">
                  <a href="mailto:info@pcmfinancial.ca" className="hover:text-white transition-colors">info@pcmfinancial.ca</a>
                </p>
              </div>
            </div>
            
            <div className="md:col-span-3">
              <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                <div>
                  <h4 className="text-white font-semibold mb-4">Quick Links</h4>
                  <ul className="space-y-2">
                    <li><a href="/services" className="text-sm text-gray-400 hover:text-white transition-colors">Services</a></li>
                    <li><a href="/about" className="text-sm text-gray-400 hover:text-white transition-colors">About Us</a></li>
                    <li><a href="/case-studies" className="text-sm text-gray-400 hover:text-white transition-colors">Case Studies</a></li>
                    <li><a href="/testimonials" className="text-sm text-gray-400 hover:text-white transition-colors">Testimonials</a></li>
                    <li><a href="/contact" className="text-sm text-gray-400 hover:text-white transition-colors">Contact</a></li>
                  </ul>
                </div>
                
                <div>
                  <h4 className="text-white font-semibold mb-4">Resources</h4>
                  <ul className="space-y-2">
                    <li><a href="/blog" className="text-sm text-gray-400 hover:text-white transition-colors">Blog</a></li>
                    <li><a href="/family-insurance" className="text-sm text-gray-400 hover:text-white transition-colors">Family Protection</a></li>
                    <li><a href="/business-insurance" className="text-sm text-gray-400 hover:text-white transition-colors">Business Insurance</a></li>
                    <li><a href="/private-advisory/process" className="text-sm text-gray-400 hover:text-white transition-colors">Advisory Process</a></li>
                  </ul>
                </div>
                
                <div>
                  <h4 className="text-white font-semibold mb-4">Client Access</h4>
                  <ul className="space-y-2">
                    <li><a href="/login" className="text-sm text-gray-400 hover:text-white transition-colors">Advisor Login</a></li>
                    <li><a href="/client-portal/login" className="text-sm text-gray-400 hover:text-white transition-colors">Client Portal</a></li>
                    <li><a href="/portal/account-aggregation" className="text-sm text-gray-400 hover:text-white transition-colors">Account Aggregation</a></li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          
          {/* SEO Footer Links */}
          <FooterSEOLinks />
          
          {/* Copyright */}
          <div className="mt-8 pt-8 border-t border-gray-800 text-center">
            <p className="text-sm text-gray-400">
              &copy; {new Date().getFullYear()} Paslawski Capital Management. All rights reserved.
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
}